var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNivel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1076.11 962.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,100.67C5.07,90.51,6.22,79,11.47,68.83,33.38,26.43,68.2,3.86,115.56.18,117,.07,118.35,0,119.75,0Q537.8,0,955.83.14a119.72,119.72,0,0,1,111.76,76c30.38,77.73-23.95,161.1-107.49,164.91-3.15.15-6.3.16-9.45.16q-412.78,0-825.58,0c-56.76,0-101.85-31.77-119.4-83.32C3.72,152.14,4.25,145.56,0,140.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,460c3.62-2.85,3.13-7.35,4.14-11.12,13.14-49.37,59.24-87.08,110.34-87.49,98.72-.8,197.46-.47,296.19-.47,88.23,0,176.46-.29,264.68.5,52.55.46,102.57,45.61,110.5,97.72,10.51,69-30.82,127.86-99.07,140.52-9.19,1.7-18.81,1.5-28.24,1.51q-264.16.12-528.33.06C62,601.25,21,570.17,2,504c-.22-.78-1.31-1.32-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,821.5c3.7-10.28,6.46-21,11.27-30.77C33.2,746.3,69.66,722.15,118.81,721.3c79.1-1.36,158.26-1,237.38-.16,61.55.7,112.46,47.32,118.55,106.28,6.47,62.7-33.12,118-94.76,131.86a136.09,136.09,0,0,1-30.21,2.91c-74.23-.13-148.46-.76-222.68.13-70.57.85-116.94-48.19-125.19-98.78-.12-.79-1.24-1.41-1.9-2.11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNivel);
export default __webpack_public_path__ + "static/media/nivel.8068d4ef64e7c8ba02bec012d273a5bc.svg";
export { ForwardRef as ReactComponent };